// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type KontakteImportReport } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useImportKontakteCsv(): (
  aufgabeId: string,
  formData: { file: Blob }
) => Promise<KontakteImportReport> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, formData) =>
      (await getAPI()).kontakte.importKontakteCsv({ aufgabeId, formData }),
    [getAPI]
  );
}
